var path = 'app/templates/partials/notifications.html';
var html = "<div class=\"alert-container\" ng-repeat=\"alert in alerts\">\n  <div class=\"alert\" ng-class=\"{danger: 'alert-danger', success: 'alert-success', info: 'alert-info', warning: 'alert-warning', notification: 'alert-notification'}[alert.type]\">\n    <div class=\"content\">\n      <a class=\"close\" ng-click=\"MessageService.close($index)\">\n        <span class=\"icon icon-cross\"></span>\n      </a>\n      <p ng-repeat=\"message in alert.messages\">\n        <span ng-if=\"!message[1]\" class=\"message\">{{message[0]}}</span>\n        <a ng-if=\"message[1]\" class=\"message\" ui-sref=\"{{message[1]}}\">{{message[0]}}</a>\n      </p>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/templates/partials/notifications.html
 ** module id = 115
 ** module chunks = 0
 **/